import { getGenderFromTGenderValue, isTGender } from '~constants/gender';

import { FILTER_MAX_AGE, FILTER_MIN_AGE } from '../model/constants';
import type { TGridFilters } from '../model/types';
import { isCreatedBy } from '../model/types';

export const parseFilters = ({
	filters,
}: {
	filters: { [key: string]: string | undefined };
}) => {
	const retValue = {} as TGridFilters;
	const { minAge, maxAge, gender, desire, keyword, createdBy } = filters;
	if (minAge) {
		const parsedAge = parseInt(minAge);
		if (
			Number.isFinite(parsedAge) &&
			parsedAge > FILTER_MIN_AGE &&
			parsedAge < FILTER_MAX_AGE
		) {
			retValue.minAge = parsedAge;
		}
	}
	if (maxAge) {
		const parsedAge = parseInt(maxAge);
		if (
			Number.isFinite(parsedAge) &&
			parsedAge > FILTER_MIN_AGE &&
			parsedAge < FILTER_MAX_AGE
		) {
			retValue.maxAge = parsedAge;
		}
	}
	if (gender && isTGender(gender)) {
		retValue.gender = getGenderFromTGenderValue(gender);
	}
	if (desire) {
		retValue.desire = desire;
	}
	if (keyword) {
		retValue.keyword = keyword;
	}
	if (createdBy && isCreatedBy(createdBy)) {
		retValue.createdBy = createdBy;
	}

	return retValue;
};
